import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de molarite (mol/L)";
const DESCRIPTION =
  "Calculatrice de molarite (mol/L). Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "molarity calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/molarity-calculator/";
function MolarityCalculator() {
  const [moles, setMoles] = useState("");
  const [volume, setVolume] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!moles || !volume) {
        setError("Veuillez entrer moles et volume");
        setResult(null);
        return;
      }
      const n = parseFloat(moles);
      const v = parseFloat(volume);
      if (n < 0 || v <= 0) {
        setError("Le volume doit être positif");
        setResult(null);
        return;
      }
      const molarity = n / v;
      setResult(molarity.toFixed(4));
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de molarité calcule la concentration molaire d'une solution.
                  Formule: Molarité (M) = Nombre de moles / Volume en litres. C'est une mesure
                  courante de concentration en chimie.
                </p>
                <ul>
                  <li>Calcul de concentration molaire</li>
                  <li>Résultats en mol/L (M)</li>
                  <li>Utile pour les solutions chimiques</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Nombre de moles
                      </label>
                      <input
                        type="number"
                        value={moles}
                        onChange={(e) => setMoles(e.target.value)}
                        placeholder="Entrez les moles"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Volume (litres)
                      </label>
                      <input
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Entrez le volume"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Molarité = <strong>{result} M</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Definition de la molarite</h3></div>
              <div className="info-section-body">
                <p>La molarite exprime la concentration d'une solution en moles de solute par litre de solution. Elle se note M et permet de comparer facilement des solutions de concentrations differentes.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Formule de calcul</h3></div>
              <div className="info-section-body">
                <p>La formule est M = n / V, avec n le nombre de moles et V le volume en litres. Si votre volume est en mL, convertissez d'abord en litres pour eviter une erreur de facteur 1000.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Applications pratiques</h3></div>
              <div className="info-section-body">
                <p>La molarite est utilisee pour preparer des solutions standard, realiser des dosages et interpreter des resultats de laboratoire. C'est une grandeur fondamentale en chimie analytique et en chimie generale.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default MolarityCalculator;
